// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3DiqY","errors":"Errors_errors__24rqT"};